export function isStringEmpty(str: string): boolean {
  return !str || str.trim().length === 0;
}

export function getShortText(text: string | null | undefined, maxCharacters: number): string {
  if (!text) return "";
  const tempElement = document.createElement("div");
  tempElement.innerHTML = text;
  const cleanText = tempElement.textContent || tempElement.innerText || "";
  return cleanText.length > maxCharacters ? cleanText.substring(0, maxCharacters) + "..." : cleanText;
}

export function hasComment(comment: string | null | undefined): boolean {
  if (!comment) return false;
  const div = document.createElement("div");
  div.innerHTML = comment;
  const text = (div.textContent || div.innerText || "").replace(/ /g, " ").trim();
  return text.length > 0;
}
